import { type ComponentProps, type FC } from "react";
import { type ViewProps } from "react-native";
import { OTPInput, SlotProps } from "input-otp";

import { cn } from "@/utils/tailwind";

import { VnBox } from "../VnBox";
import { VnText } from "../VnText/VnText";

type BaseOTPInputPropsType = ComponentProps<typeof OTPInput> & {
  containerClassName?: string;
};

export const BaseOTPInput: FC<BaseOTPInputPropsType> = ({
  className,
  containerClassName,
  ...props
}) => {
  return (
    <OTPInput
      data-slot="input-otp"
      containerClassName={cn(
        "flex flex-row items-center gap-2",
        containerClassName,
      )}
      className={cn("disabled:cursor-not-allowed", className)}
      textAlign="center"
      {...props}
    />
  );
};

export const BaseOTPInputGroup: FC<ViewProps> = ({ className, ...props }) => {
  return (
    <VnBox
      data-slot="input-otp-group"
      className={cn(
        "flex w-full flex-row items-center justify-center gap-2",
        className,
      )}
      {...props}
    />
  );
};

type BaseOTPInputSlotPropsType = SlotProps & {
  className?: string;
};

export const BaseOTPInputSlot: FC<BaseOTPInputSlotPropsType> = ({
  className,
  char,
  hasFakeCaret,
  isActive,
  ...props
}) => {
  return (
    <div
      data-slot="input-otp-slot"
      data-active={isActive}
      className={cn(
        "shadow-xs aria-invalid:border-destructive data-[active=true]:aria-invalid:border-destructive data-[active=true]:aria-invalid:ring-destructive/20 dark:data-[active=true]:aria-invalid:ring-destructive/40 dark:data-[active=true]:aria-invalid:ring-destructive/40 data-[active=true]:ring-ring/50 dark:bg-background/50 border-input bg-background data-[active=true]:border-ring relative flex h-10 w-10 items-center justify-center rounded-lg border outline-none transition-all data-[active=true]:z-10 data-[active=true]:ring-[3px]",
        className,
      )}
      {...props}>
      {char !== null && <VnText variant="lgBold">{char}</VnText>}
      {hasFakeCaret && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="animate-caret-blink bg-foreground h-4 w-px duration-1000" />
        </div>
      )}
    </div>
  );
};
